import { gql, useLazyQuery } from "@apollo/client";
import {
  ListLinkServiceQuery,
  ListLinkServiceQueryVariables,
} from "../generated/graphql";

const LIST_LINKSERVICE_QUERY = gql`
  query listLinkService($input: ListLinkServiceInput!) {
    listLinkService(input: $input) {
      ok
      err
      totalPages
      totalResults
      row
      linkservice {
        id
        name
        minAmount
        isActive
        useDeliveryFee
        address
        operationFrom
        operationTo
      }
    }
  }
`;
export interface IListLinkServiceQuery {
  listLinkService: {
    ok: boolean;
    err: string;
    totalPages: number;
    totalResults: number;
    row: number;
    linkservice: {
      id: number;
      name: string;
      minAmount: number;
      isActive: boolean;
      useDeliveryFee: boolean;
      address: string;
      operationFrom: string;
      operationTo: string;
    }[];
  };
}

export interface IListLinkServiceInput {
  end?: string;
  page?: number;
  row?: number;
  search?: string;
  start?: string;
}
export interface IListLinkServiceQueryVariables {
  input: IListLinkServiceInput;
}

export const useListLinkService = (
  onCompleted?: (data: IListLinkServiceQuery) => void
) => {
  return useLazyQuery<IListLinkServiceQuery, IListLinkServiceQueryVariables>(
    LIST_LINKSERVICE_QUERY,
    { onCompleted, fetchPolicy: "network-only" }
  );
};
